import handlersMapper from '../mappers/handlersMapper';
import { RETRIEVE_OUTBOUND_HANDLER_SUCCESS } from '../actions/types/HandlerActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

export const initialState = [];

export const outboundHandlerReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_OUTBOUND_HANDLER_SUCCESS:
      return handlersMapper(action.payload);
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

